import { z } from "zod";

import { auditDate } from "@/schemas";

export const tesFireDrillSchema = z.object({
  locationId: z.string().min(1, "Required"),
  auditDate: auditDate,
  reviewerId: z.string().min(1, "Required"),
  signalType: z.string(),
  fireParticipantsStaff: z.string().trim().min(1, "Required"),
  fireParticipantsPersonsSupported: z.string().trim().min(1, "Required"),
  meetingPlace: z.string().trim().min(1, "Required"),
  evacDurationMinutes: z.coerce.number().min(0),
  evacDurationSeconds: z.coerce
    .number()
    .min(0)
    .max(59, "Seconds must be less than 60"),
  exitUsed: z.string().trim().min(1, "Required"),
  drillStatus: z.string().trim().min(1, "Required"),
  drillStatusOther: z.string().optional(),
  fireComments: z.string().optional(),
  disasterStartTime: z.coerce.date(),
  disasterParticipantsStaff: z.string().trim().min(1, "Required"),
  disasterParticipantsPersonsSupported: z.string().trim().min(1, "Required"),
  disasterIssues: z.string().trim().min(1, "Required"),
  disasterIssueDescription: z.string().optional(),
  disasterComments: z.string().optional(),
  exitVaried: z.string().trim().min(1, "Required"),
  alarm: z.string().trim().min(1, "Required"),
  alarmSent: z.string().trim().min(1, "Required"),
});

export const tesFireDrillEditSchema = z.object({
  ...tesFireDrillSchema.shape,
  auditDate: z.coerce.date(),
});
